import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HeaderComponent } from '../../components/header/header.component';
import { GlobalService } from '../../services/global.service';
import { ButtonComponent } from '../../components/button/button.component';
import { ConfirmationPopupComponent } from '../../components/confirmation-popup/confirmation-popup.component';
import { ModalComponent } from '../../components/modal/modal.component';
import { PluralPipe } from '../../pipes/plural.pipe';
import { AgGridListComponent } from "../../components/ag-grid-list/ag-grid-list.component";
import { ListActionButtonsComponent } from '../../components/list-action-buttons/list-action-buttons.component';
import { SelectInputComponent } from '../../components/select-input/select-input.component';
import { DropdownService } from '../../services/dropdown.service';
import { CollegeService } from '../../services/college.service';
import { ValidationService } from '../../services/validation.service';
import { SearchInputComponent } from '../../components/search-input/search-input.component';
import { BulkUploadComponent } from '../../components/bulk-upload/bulk-upload.component';
import { FilterByKeyAndValuePipe } from '../../pipes/filter-by-key-and-value.pipe';
import { DropdownUploadButtonComponent } from '../../components/dropdown-upload-button/dropdown-upload-button.component';

@Component({
  selector: 'app-college-list-page',
  imports: [HeaderComponent, ButtonComponent, FilterByKeyAndValuePipe, CommonModule, ConfirmationPopupComponent, ModalComponent, PluralPipe, AgGridListComponent, SelectInputComponent, SearchInputComponent, BulkUploadComponent, DropdownUploadButtonComponent, FormsModule],
  templateUrl: './college-list-page.component.html',
})

export class CollegeListPageComponent {
  @ViewChild('confirmation_delete_modal') confirmation_delete_modal: ConfirmationPopupComponent | undefined;
  @ViewChild('confirmation_disabled_modal') confirmation_disabled_modal: ConfirmationPopupComponent | undefined;
  @ViewChild('view_modal') view_modal: ModalComponent | undefined;

  @ViewChild('bulk_modal') bulk_modal: any
  page_name = 'College';
  params: any = {};
  selected_college_ids: any = {}
  items: any = [];
  isSubmitting = false;

  filter_country_id: any = null;
  filter_state_id: any = null;
  filter_district_id: any = null;
  last_grid_filter: any = {};

  city_cols: any = [
    { field: 'name', headerName: 'College Name', filter: true, flex: 2, },
    { field: 'code', headerName: 'Code', filter: true, flex: 1, },
    {
      headerName: 'University', filter: true, flex: 2,
      valueGetter: (p: any) => p.data?.University?.name || '',
      cellRenderer: (p: any) => {
        const name = p.data?.University?.name || '';
        const code = p.data?.University?.code || '';
        return code ? `${name} (${code})` : name;
      }
    },
    { field: 'City.name', headerName: 'City', filter: true, flex: 1, },
    {
      headerName: 'Contact', filter: true, flex: 2,
      cellStyle: { display: 'flex', alignItems: 'center' },
      valueGetter: (p: any) => [p.data?.contact, p.data?.email].filter(Boolean).join(', '),
      cellRenderer: (p: any) => {
        const countryCode = p.data?.City?.District?.State?.country?.code || '';
        const contact = p.data?.contact || '';
        const email = p.data?.email || '';
        const prefix = countryCode ? (countryCode.startsWith('+') ? countryCode : `+${countryCode}`) : '';
        const displayContact = contact ? `${prefix}${contact}` : '';
        return `<div style="display:flex;flex-direction:column;justify-content:center;line-height:1.5">
          ${displayContact ? `<span style="font-weight:500;color:#111827;font-size:14px">${displayContact}</span>` : ''}
          ${email ? `<span style="color:#9CA3AF;font-size:13px">${email}</span>` : ''}
        </div>`;
      }
    },
    { field: 'address', headerName: 'Address', filter: true, flex: 1, },
    { headerName: "", sortable: false, cellRenderer: ListActionButtonsComponent, headerClass: 'custom-header-center', cellRendererParams: { actions: this.actions.bind(this) }, editable: false, pinned: 'right', width: 130, minWidth: 130, maxWidth: 130 }
  ];

  bulk_columns = [
    { column_name: 'Country Name', type: 'link', linked_list: 'country_list', linked_from: 'country', return_as: 'country_id', returning_key: 'id', sample_value: 'India' },
    { column_name: 'State Name', type: 'link', linked_list: 'state_list', return_as: 'state_id', returning_key: 'id', sample_value: 'Maharashtra' },
    // { column_name: 'Division Name', type: 'link',linked_list: 'division_list',returning_key: 'id', return_as: 'division_id', sample_value: 'Mumbai' },
    { column_name: 'District Name', type: 'link', linked_list: 'district_list', returning_key: 'id', return_as: 'district_id', sample_value: 'Thane' },
    // { column_name: 'Taluka Name', type: 'link',linked_list: 'taluka_list',returning_key: 'id', return_as: 'taluka_id', sample_value: 'Suburban' },
    { column_name: 'City Name', type: 'link', linked_list: 'city_list', returning_key: 'id', return_as: 'city_id', sample_value: 'Mumbai Suburban' },
    { column_name: 'University', type: 'link', linked_list: 'university_list', returning_key: 'id', return_as: 'university_id', sample_value: 'ABC University' },
    { column_name: 'College Name', type: 'text', return_as: 'name', sample_value: 'ABC College', is_unique: true, min_length: this.vs.min_length_name, max_length: this.vs.max_length_name, regex: this.vs.name_pattern, regex_error: `Please enter a valid ${this.page_name} Name` },
    { column_name: 'College Code', type: 'text', return_as: 'code', sample_value: 'ABC123', is_unique: true, min_length: this.vs.min_length_code, max_length: this.vs.max_length_code, unique_error: 'College code already exists', regex: this.vs.code_pattern },
    { column_name: 'Email', type: 'text', return_as: 'email', sample_value: 'abc@gamil.com', skip_validation: true, regex: this.vs.email_pattern },
    { column_name: 'Contact', type: 'text', return_as: 'contact', sample_value: '2345678901', skip_validation: true, regex: this.vs.contact_pattern, min_length: this.vs.min_length_contact, max_length: this.vs.max_length_contact },
    { column_name: 'Address', type: 'text', return_as: 'address', sample_value: 'gggj', skip_validation: true, regex: this.vs.address_pattern, max_length: this.vs.max_length_address },
  ];

  actions(row: any) {
    let actions: any = []
    actions.push({ text: row.is_active ? 'Disable' : 'Enable', shortcut: 'u', color: 'gray', icon: row.is_active ? 'bx bx-block' : 'bx bx-check-circle', function: this.disable.bind(this), permissions: this.gs.user_role_data?.masters_college_disable })
    actions.push({ text: 'View', shortcut: 'u', color: 'sky', icon: 'bx bx-eye', function: this.open_view_modal.bind(this), permissions: this.gs.user_role_data?.masters_college_view })
    actions.push({ text: 'Edit', shortcut: 'u', color: 'sky', icon: 'bx bx-edit', disabled: row.is_active === false, function: this.open_form_modal.bind(this), permissions: this.gs.user_role_data?.masters_college_update })
    actions.push({ text: 'Delete', shortcut: 'd', color: 'red', icon: 'bx bx-trash', function: this.delete_modal_open.bind(this), permissions: this.gs.user_role_data?.masters_college_delete })
    return actions
  }
  constructor(public gs: GlobalService, public route: Router, public cs: CollegeService, public ar: ActivatedRoute, public ds: DropdownService, public vs: ValidationService) {}
  async ngOnInit() {
    await this.ds?.get_dropdown_list(['country', 'state', 'distric', 'city', 'university', 'program', 'stream']);
    this.ar.queryParams.subscribe(async (params: any) => {
      this.params = { ...params }
      await this.get_list(this.params)

    })
  }
  async get_list(filter?: any) {
    try {
      this.last_grid_filter = filter || {};
      const merged = {
        ...filter,
        ...(this.filter_country_id ? { country_id: this.filter_country_id } : {}),
        ...(this.filter_state_id ? { state_id: this.filter_state_id } : {}),
        ...(this.filter_district_id ? { district_id: this.filter_district_id } : {}),
      };
      const res = await this.cs.get_list(merged);
      this.items = res;
    } catch (error: any) {
      console.error("Error fetching College list:", error);
    }
  }

  on_country_filter() {
    this.filter_state_id = null;
    this.filter_district_id = null;
    this.get_list(this.last_grid_filter);
  }

  on_state_filter() {
    this.filter_district_id = null;
    this.get_list(this.last_grid_filter);
  }

  on_district_filter() {
    this.get_list(this.last_grid_filter);
  }

  download() {
    if (!this.items?.data?.length) return;
    const rows = this.items.data;
    const headers = ['College Name', 'College Code', 'University', 'City', 'Contact', 'Email', 'Address'];
    const csv = [
      headers.join(','),
      ...rows.map((r: any) => {
        const countryCode = r?.City?.District?.State?.country?.code || '';
        const prefix = countryCode ? (countryCode.startsWith('+') ? countryCode : `+${countryCode}`) : '';
        return [
          `"${r.name || ''}"`,
          `"${r.code || ''}"`,
          `"${r.University?.name || ''}"`,
          `"${r.City?.name || ''}"`,
          `"${r.contact ? prefix + r.contact : ''}"`,
          `"${r.email || ''}"`,
          `"${r.address || ''}"`,
        ].join(',');
      })
    ].join('\n');
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'college-list.csv';
    a.click();
    URL.revokeObjectURL(url);
  }
  async delete_modal_open(item: any, index: any) {
    this.selected_college_ids = item;
    this.confirmation_delete_modal?.open();
  }
  async disable(item: any, index: any) {
    this.selected_college_ids = item;
    this.confirmation_disabled_modal?.open();
  }
  open_view_modal(item: any) {
    console.log(item);
    this.selected_college_ids = item || {};
    this.view_modal?.open();
  }
  async delete_college() {
    let res = await this.cs.delete(this.selected_college_ids.id);
    if (res != undefined) {
      this.gs.toastr_shows_function(res?.message, 'Success', 'success');
    }
    this.selected_college_ids = {};
    this.confirmation_delete_modal?.close()
    this.ds.invalidate_dropdown_cache('college');
    await this.get_list(this.params);
  }
  async update_country(item: any) {
    try {
      await this.cs.update(this.selected_college_ids.id, { is_active: !item });
      this.gs.toastr_shows_function('Status has been successfully updated', 'Success', 'success');
      this.confirmation_disabled_modal?.close();
      this.ds.invalidate_dropdown_cache('college');
      await this.get_list(this.params);
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }
  async bulk_delete(ids: any[]) {
    for (let id of ids) {
      await this.cs.delete(id);
    }
    this.gs.toastr_shows_function('Records deleted successfully', 'Success', 'success');
    this.ds.invalidate_dropdown_cache('college');
    await this.get_list(this.params);
  }
  open_form_modal(item?: any) {
    if (item?.id) {
      this.route.navigate(['college/edit'], { queryParams: { id: item.id } });
    } else {
      this.route.navigate(['college/add']);
    }
  }
  async bulk_upload(data: any, spinner: any) {
    try {
      const updatedData = data.map((item: any) => ({
        ...item,
        contact: item.contact + '',
        is_active: true
      }));
      await this.gs.bulk_form_submission(updatedData, this.cs, this.params, this.get_list.bind(this), this.bulk_modal, spinner)
    } catch (error: any) {
      this.gs.toastr_shows_function(error.error.message, 'Error', 'error');
    }
  }

}
